
import './App.css';
import InputForm from './components/InputForm';
import QrCode from './components/QrCode';

function App() {
  return (
    <div className="App">
      <InputForm />
      <QrCode />
     
    </div>
  );
}

export default App;
